const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class BookingQueryConnector {

  constructor(configuration) {
    this.httpClient = axios.create(configuration);
  }

  async getById({ id }) {
    try {
      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/bookings/${id}`);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getPubliclySharedBooking({ bookingId, token }, options = {}) {
    try {
      const { data } = await this.httpClient.get(`/v1/public/bookings/${bookingId}/shared?token=${token}`, options);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }

}

module.exports = {
  BookingQueryConnector,
};
